'use client';

import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import CardBlogPost from 'src/components/Card/CardBlogPost';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

export type BlogReviewedPostsProps =
    SliceComponentProps<Content.BlogReviewedPostsSlice> & {
        context: { uid: string };
    };

const BlogReviewedPosts = ({ slice, context }: BlogReviewedPostsProps) => {
    const uid = context.uid; //doctors url (name) i.e. paul-goodridge
    const doctorsName = uid.split('-').join(' ');

    const [articles, setArticles] = useState([]);

    // This should be an infinite query
    useEffect(() => {
        fetch(
            '/api/get-blog-by-doctor?doctorName=' +
                encodeURIComponent(doctorsName),
        )
            .then((response) => response.json())
            .then((result) => {
                setArticles(result);
            });
    }, []);

    return articles && articles.length > 0 ? (
        <section className="mb-4 max-w-[50rem] bg-sand-light px-4 py-4 md:m-auto md:px-0 lg:py-8 xl:rounded-xl">
            <strong className="text-[1.125rem]">{slice.primary.title}</strong>
            <div className="mx-auto">
                {articles && (
                    <div
                        className={classNames(
                            'mt-4 flex flex-nowrap space-x-4 overflow-x-auto pb-4',
                            'lg:pl-0',
                            articles.length <= 2 && 'md:overflow-hidden',
                        )}
                    >
                        {articles.map((post, index) => {
                            return (
                                <CardBlogPost
                                    post={post}
                                    key={index}
                                    className={classNames(
                                        'md:!w-64 md:!shrink-0',
                                        articles.length === index &&
                                            'mr-4 md:mr-0',
                                    )}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    ) : null;
};

export default BlogReviewedPosts;
